export const ES = {
    Interno:{
        Principal:"Bienvenidos",
        CerrarSesion:"Cerrar sesión",
        Menu:{
            OrdenCompra:"Orden Compra",
            SolCambioCuenta:"Sol. Cambio Cuenta Bancaria",
            Trabajadores:"Trabajadores",
            Admin:"Admin",
            istracion:"istración",
            InvitacionProveedores:"Invitación a proveedores"
        },
        OCDocPendiente:{
            Titulo:"Orden Compra",
            ComoCargo:"¿Cómo cargo mi factura?",
            BuscarOC:"Buscar orden de compra no encontrada",
            OC:"OC",
            Contrato:"Contrato",
            FechaOC:"Fecha OC",
            PorEnviar:"Por enviar",
            Certificados:"Certificados",
            Soportes:"Soportes",
            Facturas:"Facturas",
            Accion:"Acción",
            RFCRecept:"RFC Recept.:",
            Moneda:"Moneda",
            FechaReqSitio:"F. Req. en Sitio",
            Subtotal:"Subtotal",
            Comprador:"Comprador",
            Impuestos:"Impuestos",
            Activador:"Activador",
            Retenidos:"Retenidos",
            Total:"Total",
            HeaderFacturasTutorial:"¿Cómo cargar mi factura?",
            Tutorial_Paso1Titulo:"1.- Ordenes de compra",
            Tutorial_Paso1Desc:'Busca la orden de compra y selecciona la opcion "Facturas" en el menú desplegable de la columna acción',
            Tutorial_Paso2Titulo:"2.- Seleccionando concepto",
            Tutorial_Paso2Desc:"Subir la factura para el concepto que aplique.",
            Tutorial_Paso3Titulo:"3.- Carga de factura",
            Tutorial_Step1:"Selecciona las entradas para calcular el importe de la factura (En caso de ser Recepción de material).",
            Tutorial_Step2:"Carga el archivo .xml (Solo aplicable para proveedores mexicanos).",
            Tutorial_Step3:"Carga el archivo .pdf.",
            Tutorial_Step4:"Revisar los montos de la factura.",
            Tutorial_Step5:"Oprime el boton Enviar.",
            Tutorial_BtnVideo:"Ver videotutorial",
            Tutorial_BtnCerrar:"Cerrar",
            HeaderBuscarOC:"Búsqueda de Órdenes de compra",
            BuscarOCInstruccion:"Introduce la orden de compra para ver el motivo por el cual no se visualiza en la lista.",
            BuscarOCLabel:"Orden Compra:",
            BuscarOCBtn:"Buscar",
            Concepto:"Concepto",
            MontoConImpuestos:"Monto con<br>impuestos",
            TotalRemision:"Total<br>Remisión",
            Facturado:"Facturado",
            PorFacturar:"Por Facturar",
            Factura:"Factura",
            Subir:"Subir"
        },
        EnvioFacturas:{
            Titulo:"Envio Facturas",
            OrdenCompra:"Orden de compra",
            Moneda:"Moneda",
            FechaReqSitio:"Fecha req. en sitio",
            Subtotal:"Subtotal",
            Comprador:"Comprador",
            Impuestos:"Impuestos",
            Total:"Total",
            Concepto:"Concepto",
            Monto:"Monto",
            Facturado:"Facturado",
            PorFacturar:"Por Facturar",
            Factura:"Factura",
            TotalesConImpuesto:"Totales Con Impuesto",
            Subir:"Subir",
            ArchivoXML:"Archivo XML",
            ArchivoPDF:"Archivo PDF",
            NumFactura:"Num. Factura",
            Impuesto:"Impuesto",
            FechaFactura:"F. Factura",
            TotalFactura:"Total Factura",
            Referencia:"Referencia",
            Comentarios:"Comentarios",
            BtnCancelar:"Cancelar",
            BtnEnviar:"Enviar"
        },
        CambioCuentaBancaria:{
            Titulo:"Solicitud de cambio de cuenta bancaria",
            Motivo:"Motivo del cambio de cuenta bancaria:",
            MotivoPH:"Motivo",
            ModalAvisoP1:"La solicitud de cambio de cuenta requiere de enviar la documentación solicitada y se enviará a Arendal para su aprobación.",
            ModalAvisoP2:"Nos pondremos en contacto con el representante legal de la compañía para verificar la información.",
            BtnProceder:"Proceder",
            ModalEnProcesoTitulo:"Solicitud en proceso",
            ModalEnProceso:"Ya existe una solicitud de cambio de cuenta bancaria este mes, favor de esperar respuesta.",
            BtnRegresar:"Regresar",
            Reemplazar:"Reemplazar"
        },
        InvitacionProveedores:{
            Titulo:"Invitación a proveedores",
            Estatus:"Estatus",
            VerSoloBtnText:"Ver solo mis invitaciones",
            BtnInvitar:"Invitar",
            FechaInvitacion:"F. Invitación",
            FechaEstatus:"F. Estatus",
            Proveedor:"Proveedor",
            Contacto:"Contacto",
            CorreoContacto:"Correo Contacto",
            InvitadoPor:"Invitado por",
            ColEnviar:"Enviar",
            ColCancelar:"Cancelar",
            ModalTitulo:"Invitar a proveedor",
            TipoProveedor:"Tipo Proveedor",
            TipoPersona:"Tipo Persona",
            SolicitarSubcontratos:"Solicitar documentación adicional de subcontratos.",
            Proyecto:"Proyecto",
            Pais:"País",
            RazonSocial:"Razón soc.",
            RazonSocialPH:"Razón social",
            NomCom:"Nom. Com.",
            NomComPH:"Nombre Comercial",
            DiasPlazo:"Días Plazo",
            DiasPlazoHint:"Días de plazo",
            ProveedorBuscarPH:"Escribe 5 caracters para buscar el proveedor...",
            SeccionContacto:"Contacto",
            Nombres:"Nombres",
            NombresPH:"Nombres",
            Apellidos:"Apellidos",
            ApPaternoPH:"Ap. Paterno",
            ApMaternoPH:"Ap. Materno",
            Puesto:"Puesto",
            PuestoPH:"Puesto",
            CorreoLabel:"Correo",
            CorreoPH:"correo@empresa.com",
            Telefono:"Teléfono",
            ComentariosInvitacion:"Comentarios Invitación",
            BtnCancelar:"Cancelar",
            BtnEnviarInvitacion:"Enviar Invitación"
        },
        OrdenCompra:{
            a:""
        },
        Trabajadores:{
            a:""
        }
    },
    Externo:{
        Login:{
            TituloLogin:"Iniciar sesión con correo registrado",
            CorreoHint:"Correo",
            ContrasenaHint:"Contraseña",
            BtnLogin:"Entrar",
            RecordarContrasena:"Recordar Contraseña",
            OlvideContrasena:"Olvide mi contraseña",
            BtnRegistro:"Registrar mi correo (Ya soy proveedor de Arendal)",
            Notify:{
                IntentosExcedidos:"Se excedió el numeros de intentos permitidos (5), intenta de nuevo en al menos un minuto.",
                TerminoTiempoEspera:"Termino el tiempo de espera, intenta de nuevo.",
                NecesarioCorreoContrasena:"Es necesario ingresar correo y contraseña."
            }
        },
        RegistroProveedor:{
            msgProveedorRegistrado:"Los datos del proveedor ya fueron registrados.",
            msgInvitacionNoEncontrada:"La invitación no fue encontrada o fue eliminada.",
            Titulo:"Datos del proveedor",
            TituloRegistrado:"Datos registrados con éxito.",
            msgTituloRegistrado:"Los datos fueron registrados con éxito, favor de esperar la autorización del registro, puede cerrar esta ventana.",
            PaisOrigen:"País de origen",
            RFCTAX:"RFC / Tax ID",
            NomComercial:"Nom. Comercial",
            NomComercialHint:"Nom. Comercial",
            RazonSocial:"Razón Social",
            RazonSocialHint:"Razón Social",
            TipoEmpresa:"Tipo de empresa",
            PersonaMoral:"Persona Moral",
            PersonaFisica:"Persona Física",
            DiasPlazo:"Días de plazo",
            ContactoArendal:"Contacto en Arendal",
            ContactoArendalHint:"Grupo Compras",
            //?Documentacion
                tabDocumentacion:"Documentación",
                tabDireccion:"Dirección",
                tabDatosContacto:"Datos Contacto",
                tabCuentaBancaria:"Cuenta Bancaría",
                tbDocumento:"Documento",
                tbDescripcion:"Descripción",
                tbArchivo:"Archivo (PDF/JPG/PNG/DOC/DOCX)",
                tbSubir:"Subir",
            //?Direccion
                CalleNumero:"Calle y número",
                CalleNumeroHint:"Calle y número",
                Colonia:"Colonia",
                ColoniaHint:"Colonia",
                CP:"C.P.",
                CPHint:"C.P.",
                Ciudad:"Ciudad",
                CiudadHint:"Ciudad",
                Estado:"Estado",
                EstadoHint:"Estado",
            //?Contacto
                Nombres:"Nombres",
                NombresHint:"Nombres",
                PaternoHint:"Ap. Paterno",
                MaternoHint:"Ap. Materno",
                Puesto:"Puesto",
                PuestoHint:"Puesto",
                Correo:"Correo",
                CorreoHint:"Correo",
                Telefono:"Teléfono",
                TelefonoHint:"Teléfono",
                Direccion:"Dirección",
                DireccionHint:"Dirección",
            //?Banco
                Moneda:"Moneda",
                Banco:"Banco",
                BancoHint:"Banco",
                NumCuenta:"Núm. Cuenta",
                NumCuentaHint:"Número de cuenta",
                Titular:"Titular Cuenta",
                TitularHint:"Titular de la cuenta",
                ABA:"ABA",
                ABAHint:"ABA",
                SwiftCode:"Swift Code",
                SwiftCodeHint:"Swift Code",
            //?Boton Guardar
                BtnGuardarEnviar:"Guardar y Enviar",
            //?Notificaciones
                Notify:{
                    ExtencionIncorrecta:"Favor de seleccionar un archivo pdf, jpg, png, doc, docx",
                    ArchivoExistente:"Ya existe un archivo que fue seleccionado previamente, favor de seleccionar otro.",
                //?Validaciones Guardado
                    ValidacionSwiftCode:"Favor de introducir el swift code.",
                    ValidacionABA:"Favor de introducir el ABA.",
                    ValidacionTitular:"Favor de introducir el titular de la cuenta.",
                    ValidacionNoCuenta:"Favor de introducir el número de cuenta.",
                    ValidacionBanco:"Favor de introducir el banco.",
                    ValidacionMoneda:"Favor de introducir la moneda.",
                    ValidacionDireccion:"Favor de introducir la dirección del contacto.",
                    ValidacionTelefono:"Favor de introducir el teléfono del contacto.",
                    ValidacionCorreo:"Correo del contacto no encontrado favor de contactar al administrador.",
                    ValidacionPuesto:"Favor de introducir el puesto del contacto.",
                    ValidacionApellidoM:"Favor de introducir el apellido materno del contacto.",
                    ValidacionApellidoP:"Favor de introducir el apellido paterno del contacto.",
                    ValidacionNombres:"Favor de introducir el/los nombre(s) del contacto.",
                    ValidacionEstado:"Favor de introducir el estado.",
                    ValidacionCiudad:"Favor de introducir la ciudad.",
                    ValidacionCP:"Favor de introducir el codigo postal.",
                    ValidacionColonia:"Favor de introducir la colonia.",
                    ValidacionCalleNumero:"Favor de introducir la calle y número.",
                    ValidacionDiasPlazo:"Favor de introducir los días de plazo.",
                    ValidacionRazonSocial:"Favor de introducir la razón social.",
                    ValidacionNomComercial:"Favor de introducir el nombre comercial.",
                    ValidacionRFC:"Favor de introducir RFC / Tax ID.",
                    ValidacionPais:"Favor de seleccionar el país.",
                    ValidacionDocumentos:"Favor de cargar los documentos faltantes.",
                //?Error peticion
                    ErrorPeticion:"Ocurrió un error inesperado contacte al administrador.",
                //?Error Token
                    ErrorToken:"Sorry, no valid token found."
                }
        }
    }
};
